export function callEnumVal(str: string) {
  return str && str.length > 2 && str[0].toUpperCase() + str.substr(1);
}
